import { render, staticRenderFns } from "./ComunicacaoTransferencia.vue?vue&type=template&id=386dd031&"
import script from "./ComunicacaoTransferencia.vue?vue&type=script&lang=js&"
export * from "./ComunicacaoTransferencia.vue?vue&type=script&lang=js&"
import style0 from "./ComunicacaoTransferencia.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports